import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import {getValueFromQueryString} from '../../util/sharedFunctions';
const propTypes = {
  onConfirm: PropTypes.func.isRequired,
};

class ConfirmForm extends Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {

  }

  handleSubmit(values) {
    this.props.onConfirm(values);
  }

  render() {
    const { handleSubmit, pristine, reset, submitting } = this.props;
    let {userId, code} = this.props.location.query;

    return (
      <form>
        <div className="heading-text">
            <h4>Verification</h4>
        </div>
        <div className="page-login-input">
            <i className="login-icon fa fa-user" />
            <Field name="merchantId" component="input" type="text" placeholder="Merchant ID" />
        </div>                
        <div className="page-login-input">
            <i className="login-icon fa fa-map-marker" />
            <Field name="postcode" component="input" type="text" placeholder="Postcode" />
        </div>
        <div className="page-login-input">
            <i className="login-icon fa fa-lock" />
            <Field name="temporaryPassword" component="input" type="password" placeholder="Temporary Password" />
        </div>

        <a disabled={pristine || submitting} className="button button-green button-icon button-full half-top full-bottom" onClick={handleSubmit}>
          <i className="fa fa-angle-right" /> Verify
        </a>

        <div className="decoration" />

        <div>
          <div className="hidden">
            <Field name="userId" component="input" type="text" value={userId} />
            <input type="hidden" name="code" value={code} />
          </div>
        </div>
      </form>
    );

  }
}

ConfirmForm.propTypes = propTypes;

let Confirm = reduxForm({
  form: 'confirmForm'
})(ConfirmForm);


let mapStateToProps = function (state, ownProps) {
  let {userId} = ownProps.location.query;
  let code = getValueFromQueryString(ownProps.location.search,'code');//cuz the .query strips the '+' characters we have to get the 'code' the hard way

  return {
    initialValues: { userId: userId, code: code, merchantId: "", temporaryPassword: "" }
  };
};

Confirm = connect(mapStateToProps)(Confirm);

export default Confirm;



// WEBPACK FOOTER //
// ./app/auth/components/confirm.js